import { Divider, Paper, Stack, Typography } from "@mui/material";

import InlineCode from "@/common/components/Code/InlineCode";

export function DevDividers() {
  return (
    <Paper sx={{ p: 2 }}>
      <Typography component='div' variant='h4' sx={{ my: 2 }}>
        Dividers
      </Typography>

      <Typography component='div' variant='h5' sx={{ my: 2 }}>
        <InlineCode>MUI Divider</InlineCode>
      </Typography>
      <Stack gap={2}>
        <Divider />
        <Divider sx={{ borderWidth: 2 }} />
        <Divider sx={{ borderWidth: 3 }} />
        <Divider sx={{ borderWidth: 4 }} />
        <Divider sx={{ borderWidth: 5 }} />
      </Stack>
    </Paper>
  );
}
